import * as React from "react";
import { FormikProps, Field, Form, withFormik } from "formik"
import { useNavigate } from "react-router-dom";
import { TemplateSub } from "../../../../../components/layouts/TemplateSub";
import NewButton from "../../../../../components/uiMerge/newButton";
import * as ROUTES from "../../../../../constants/routes";
import { PhoneInputField } from "../../../../shared/PhoneInputField";
import { PhoneOtpRequestController, ViewMe } from "@njoy/controller";
import PageLoader from "src/modules/shared/PageLoader";
import ToastMessage from "../../../../../hooks/useToast";
import { extractError } from "../../../../../utils/extractError";


interface ChangePhoneNumberFormValues {
  phone: string;
}

interface ChangePhoneNumberProps {
  initialValues?: ChangePhoneNumberFormValues;
  submit?: (values: ChangePhoneNumberFormValues) => Promise<any>;
  onFinish?: (phone: string) => void;
}
const countries = [
  { code: "NG", label: "+234" },
  { code: "US", label: "+1" },
  { code: "UK", label: "+44" },
  { code: "CA", label: "+1" }
];

const ChangePhoneNumberPageInner: React.FC<FormikProps<ChangePhoneNumberFormValues> & ChangePhoneNumberProps> = (props) => {
  return (
    <TemplateSub
      page={`Change Phone Number`}
    >
      <Form className="flex flex-col mt-8 flex-1 px-[1rem]">
        <div className="w-full flex-1 flex flex-col">
          <label className="text-[#CECECF] opacity-90">Enter new phone number</label>
          <Field
            name="phone"
            placeholder="Phone number"
            component={PhoneInputField}
            countries={countries}
          />
        </div>
        <div className="mb-[2rem]">
          <div>
            <NewButton
              loading={props.isSubmitting}
              fullWidth
              variant="primary"
              type="submit"
              className="login-form-button"
              // onClick={() => navigate(ROUTES.CHANGE_PHONE_NUMBER_DETAILS_OTP)}
            >
              Save Changes

            </NewButton>
          </div>
        </div>
      </Form>

    </TemplateSub>
  );
};

const FormikChangePhoneNumberPage = withFormik<
  ChangePhoneNumberProps,
  ChangePhoneNumberFormValues
>({
  enableReinitialize: true,
  mapPropsToValues: (props) => ({
    phone: props.initialValues?.phone || "",
  }),
  handleSubmit: async (values, { props, setErrors, setSubmitting, setTouched }) => {
    try {
      setSubmitting(true);
      if (props.submit) {
        const serverErrors = await props.submit(values);

        if (serverErrors) {
          setSubmitting(false);
          ToastMessage("error", extractError(serverErrors));
          setErrors(serverErrors);
          setTouched(
            Object.keys(serverErrors).reduce(
              (acc, key) => ({ ...acc, [key]: true }),
              {} as Record<string, boolean>
            )
          );
          return;
        }

        setSubmitting(false);
        if (props.onFinish) {
          props.onFinish(values.phone);
        }
      }
    } catch (error: any) {
      setSubmitting(false);
      ToastMessage("error", (error as Error)?.message || "Something went wrong. Please try again.");
    }
  },
})(ChangePhoneNumberPageInner as any);

export const ChangePhone: React.FC = () => {
  const navigate = useNavigate();

  return (
    <PhoneOtpRequestController>
      {({ phoneOtpRequest }: {phoneOtpRequest:any}) => (
        <ViewMe>
          {({ match, loading }) => {
            if (loading || !match) {
              return <PageLoader />;
            }

            const initialValues = {
              phone: match?.customer?.phone || ""
            };

            return (
              <FormikChangePhoneNumberPage
                initialValues={initialValues}
                submit={async (values: ChangePhoneNumberFormValues) => {
                  const response = await phoneOtpRequest({
                    input: { phone: values.phone },
                  });

                  if (response === null) {
                    localStorage.setItem("phone", values.phone);
                    localStorage.setItem("email", match?.customer?.email || "");
                    navigate(ROUTES.CHANGE_PHONE_NUMBER_DETAILS_OTP);
                  }

                  return response;
                }}
              />
            );
          }}
        </ViewMe>
      )}
    </PhoneOtpRequestController>
  );
}